// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "v4assets/" + chunkId + "." + {"2552":"dbe247faa7b23055d8e2","3780":"bf7a5a59f7ed5c7f838d","4389":"5d0cbb1c820f736167df","6037":"2acec361fa53edd67f06","8287":"3449e60a6e241f4cbf52"}[chunkId] + ".css";
};